// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__HAWUr","header-dark":"header_header-dark__zuQOk","logo":"header_logo__2XFgy"};